import type { NotesTabProps } from "../../types/tabs";
import { useNotesTab } from "../../hooks/useNotesTab";
import styles from "../../styles/applicationDetail.module.css";
import { NotesTabApplicantFlagsSection } from "./NotesTabApplicantFlagsSection";
import { NotesTabAdditionalFilesSection } from "./NotesTabAdditionalFilesSection";
import { NotesTabNotesSection } from "./NotesTabNotesSection";
import { NotesTabStatusLogSection } from "./NotesTabStatusLogSection";
import { NotesTabEmailHistorySection } from "./NotesTabEmailHistorySection";
import { NotesTabSmsHistorySection } from "./NotesTabSmsHistorySection";
import { NotesTabModals } from "./NotesTabModals";

export function NotesTab(props: NotesTabProps) {
  const tab = useNotesTab(props);

  return (
    <div
      className={`${styles.tabContent} ${styles.notesPremium}`}
      data-testid="application-notes-tab-page"
    >
      <NotesTabApplicantFlagsSection tab={tab} />
      <NotesTabAdditionalFilesSection tab={tab} />
      <NotesTabNotesSection tab={tab} />
      <NotesTabStatusLogSection tab={tab} />
      <NotesTabEmailHistorySection tab={tab} />
      <NotesTabSmsHistorySection tab={tab} />
      <NotesTabModals tab={tab} />
    </div>
  );
}
